<template>
  <div v-if="value">
    <div class="mt-5 _clearfix"v-for="(email, i) in value" :key="i">
      <div class="col-xs-10 col-md-9 pd-0">
        <div class="">
          <input type="text" class="form-control form__text form__email" name="title" placeholder="อีเมล" id="ecard-mail-01" v-model="value[i]" />
        </div>
      </div>
      <div class="col-xs-2 col-md-3">
        <a href="#" class="-remove" @click.prevent="removeEmail(i)">ลบ</a>
      </div>
    </div>
    <div class="_clearboth mt-15">
      <div class="alert alert--error" v-show="error">รูปแบบอีเมลไม่ถูกต้อง</div>
      <a href="#" class="-add_plus" @click.prevent="addEmail">เพิ่มอีเมล</a>
  </div>
  </div>
</template>

<script>
  export default {
    name: 'SendEmailForm',

    props: {
      value: {
        type: Array,
        default: null
      }
    },

    data () {
      return {
        error: false
      }
    },

    methods: {
      emit () {
        this.$emit('input', this.value)
      },

      isValidEmail (email) {
        return email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      },

      validate () {
        this.error = false
        for (let i = 0; i < this.value.length; i++) {
          if (!this.isValidEmail(this.value[i])) {
            this.error = true
            return false
          }
        }
        return true
      },

      addEmail () {
        this.value.push('')
        this.emit()
      },

      removeEmail (index) {
        this.value.splice(index, 1)
        if (this.value.length === 0) {
          this.addEmail()
        }
        this.emit()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form__email {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// SendEmailForm.vue?e09fc7b8